import { Button, Drawer, Form, message, Popover, Space, Input } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { BsCheck2Square } from "react-icons/bs";
import { GiExitDoor } from "react-icons/gi";
import { RiFilterOffLine } from "react-icons/ri";
import exitVehicle from "../../../services/exitVehicle";
import { timeLap } from "../../../utils/timeLap";
import { ExportToExcel } from "../../../utils/XLSXExport";
import Moment from "react-moment";
const { Search } = Input;
export default function StationVehicles({
  setVisible,
  isVisible,
  vehicles,
  title,
  refetch,
}: any) {
  const [search, setSearch] = useState("");
  const handleExistVehicle: any = async (item: any) => {
    const data = { vehicle: item?.vehicle };
    const response = await exitVehicle(data);
    if (response.success) {
      message.success(`${item?.vehicle} Exited`);
      refetch();
    }
  };

  const [form] = Form.useForm();

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  //   useEffect(() => {}, [vehicles]);

  return (
    <Drawer
      title={`${title}`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by registration"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    vehicles?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        Registration:
                          record?.vehicle === null ? "-" : record?.vehicle,
                        "Arrived At": record?.timein,
                        "Exited At": record?.timeout ? (
                          record?.timeout
                        ) : (
                          <span className="text-yellow-600">
                            Work in progress
                          </span>
                        ),
                        "Time Taken": timeLap(record?.timein, record?.timeout),
                      };
                    }),
                    "Vehicles.xlsx"
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-36 truncate text-left font-bold">
                Registration
              </div>
              <div className="w-52 truncate font-bold">Arrived At</div>
              <div className="w-36 truncate font-bold">Exited At</div>
            </div>
            <div className="font-bold w-full">
              <div className="flex">
                <div className="mr-2 text-left flex-1">Time Stayed</div>
                <div className="truncate flex justify-end">Action</div>
              </div>
            </div>
          </div>
        </div>
        {vehicles?.map((item: any, index: number) => (
          <div className="flex py-1 border-b border-gray-300" key={index}>
            <div className="mr-2 w-10 text-center">{index + 1}.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="flex items-center">
                <div className="w-36 truncate">
                  {item?.vehicle === null ? "-" : item?.vehicle}
                </div>
                <div className="w-52">
                  <Moment format="Do, MMM YYYY hh:mm A">{item?.timein}</Moment>
                </div>

                <div className="w-36 truncate flex">
                  {item?.timeout ? (
                    <Moment
                      format="Do, MMM YYYY hh:mm A"
                      className="text-green-600"
                    >
                      {item?.timeout}
                    </Moment>
                  ) : (
                    <span className="text-yellow-600">Work in progress</span>
                  )}
                </div>
              </div>
              <div className="w-full">
                {item.timeout === null ? (
                  <div className="flex">
                    <div className="mr-2 text-left flex-1">
                      {timeLap(item?.timein, new Date())}
                    </div>

                    <Popover
                      placement="bottom"
                      title={`VEHICLE ${item?.vehicle}`}
                      content={
                        <div className="flex justify-center items-center">
                          <button
                            onClick={() => handleExistVehicle(item)}
                            className="border border-green-500 px-2 ml-1 bg-green-500 text-white"
                          >
                            Exit
                          </button>
                        </div>
                      }
                      trigger="click"
                    >
                      <button className="truncate ml-2 border p-2 flex justify-end">
                        <GiExitDoor color="red" />
                      </button>
                    </Popover>
                  </div>
                ) : (
                  <div className="flex">
                    <div className="mr-2 text-left flex-1">
                      {timeLap(item?.timein, item?.timeout)}
                    </div>
                    <div className="truncate ml-2 border p-2 flex justify-end">
                      <BsCheck2Square color="green" />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="ml-2">Total Vehicles</div>
          <div className="font-bold">
            {
              vehicles?.filter((vehicle: any) =>
                vehicle?.vehicle?.registration?.includes(search)
              ).length
            }
          </div>
        </div>
      </div>
    </Drawer>
  );
}
